// Deployment-level switches for surfaces that depend on an approval we do not
// have yet. Read once at module load; flipping one is a redeploy, not a runtime
// toggle.

/**
 * Whether to offer Google Ads as a connectable source.
 * Defaults to true now that the developer token is approved. Set
 * `VITE_GOOGLE_ADS_OFFERED=false` to hide it again.
 */
export const adsOffered = (import.meta.env.VITE_GOOGLE_ADS_OFFERED ?? "true").trim() === "true";

/**
 * Whether to offer Search Console via the Google OAuth consent screen.
 * The scope must match the consent screen exactly — shipping it early
 * breaks every Google connect. The service-account path works without this.
 * Set `VITE_GOOGLE_GSC_OAUTH=true` together with `GOOGLE_GSC_OAUTH=1` on the API.
 */
export const gscOauthOffered = (import.meta.env.VITE_GOOGLE_GSC_OAUTH ?? "").trim() === "true";
